export default __webpack_public_path__ + "static/media/DaciaBlock-Bold.08e0f4bb.woff2";